import { useStaticQuery, graphql } from 'gatsby';

const newsQuery = () => {
    const data = useStaticQuery(graphql`
        query AnnouncementQuery {
            allContentfulAnnouncement(sort: {order: DESC, fields: date}) {
                nodes {
                    title
                    contentful_id
                    content {
                        raw
                    }
                    seo_desc
                    url
                    date(formatString: "YYYY-MM-DD")
                }
            }
        }
    `);

    return data.allContentfulAnnouncement.nodes;
};

export default newsQuery;
